import * as ReduxObservable from 'redux-observable'
import * as Flash from '../../../components/flash-message'
import * as Form from '../../../components/form'
import * as Request from '../../../request'
import { ApplicationState } from '../../../rootReducer'
import * as Actions from './actions'
import * as Constants from './constants'

type OnSave = ReduxObservable.Epic<Request.RequestAction, ApplicationState>
const onSave: OnSave = (action$, store) =>
  action$.ofType(Constants.FormConstants[Form.SAVE])
    .map(store.getState)
    .map(({app, leadText}) => leadText.form.fields.id ?
      Actions.updateLeadText(app.selectedCommunity, leadText.form.fields) :
      Actions.postLeadText(app.selectedCommunity, leadText.form.fields))

type OnSuccess = ReduxObservable.Epic<any, ApplicationState>
const onSuccess: OnSuccess = (action$, store) =>
  action$.ofType(
    Request.successConstant(Constants.POST_LEAD_TEXT),
    Request.successConstant(Constants.PUT_LEAD_TEXT),
  )
    .mergeMap((action) => {
      const message = action.requestAction.options.payload.id ? 'Lead Text updated!' : 'Lead Text created!'
      return ([
        Actions.toggleModal(),
        Actions.FormActions[Form.RESET](),
        Actions.FormActions[Form.SAVE_COMPLETE](action),
        Flash.showFlashMessage(message),
      ])
    })

type ValidateForm = ReduxObservable.Epic<any, ApplicationState>
const validateForm: ValidateForm = (action$, store) =>
  action$.ofType(Constants.FormConstants[Form.UPDATE], Constants.FormConstants[Form.ENTER])
    .map(() => Form.selectFormFields(store.getState().leadText))
    .map(Form.validateFormFields(Constants.FormValidators))
    .map(Form.isFieldsValid)
    .map(Actions.FormActions[Form.VALIDATE])

export const epic = ReduxObservable.combineEpics(onSave, onSuccess, validateForm)



// WEBPACK FOOTER //
// ./src/pages/lead-text/add-edit-modal/epic.ts